"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_STAKE_HISTORY = exports.STAKE_HISTORY_BY_PROPOSAL = exports.ALL_PROPOSALS = exports.CONFIG = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.CONFIG = (type) => graphql_tag_1.default `
  ${type} Configs($id: String!) {
    configs(where: {
      id: $id
    }) {
      id
      decay
      weight
      maxRatio
      pctBase
      stakeToken {
        id
        name
        symbol
        decimals
      }
      requestToken {
        id
        name
        symbol
        decimals
      }
      maxStakedProposals
      minThresholdStakePercentage
      totalStaked
    }
  }
`;
exports.ALL_PROPOSALS = (type) => graphql_tag_1.default `
  ${type} Proposals($appAddress: String!, $first: Int!, $skip: Int!) {
    proposals(where: {
      appAddress: $appAddress
    }, first: $first, skip: $skip) {
      id
      number
      name
      link
      creator
      beneficiary
      requestedAmount
      status
      totalTokensStaked
      stakes {
        entity
        amount
      }
      appAddress
    }
  }
`;
exports.STAKE_HISTORY_BY_PROPOSAL = (type) => graphql_tag_1.default `
  ${type} StakeHistory($appAddress: String, $proposalId: String, $first: Int!, $skip: Int!) {
    stakeHistories(where : { appAddress: $appAddress, proposalId: $proposalId }, first: $first, skip: $skip) {
      id
      entity
      proposalId
      tokensStaked
      totalTokensStaked
      time
      conviction
    }
  }
`;
exports.ALL_STAKE_HISTORY = (type) => graphql_tag_1.default `
  ${type} StakeHistory($appAddress: String, $first: Int!, $skip: Int!) {
    stakeHistories(where : { appAddress: $appAddress }, first: $first, skip: $skip) {
      id
      entity
      proposalId
      tokensStaked
      totalTokensStaked
      time
      conviction
    }
  }
`;
//# sourceMappingURL=index.js.map